export const TAG_ITEM_DATA_TESTID = 'tag-wrapper';
